var _defs, _path, _path2, _path3, _path4, _path5, _path6, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMbLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110.06 61.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #333;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.72.06s-.05,0-.08,0h-16.79v15.11h.01c0,.09-.01.17-.01.26,0,2.28,1.84,4.12,4.12,4.12.06,0,.11,0,.16,0h12.59c5.38,0,9.74-4.36,9.74-9.74S60.1.06,54.72.06Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.72,23.92s-.05,0-.08,0h-16.79v15.11h.01c0,.09-.01.17-.01.26,0,2.28,1.84,4.12,4.12,4.12.06,0,.11,0,.16,0h12.59c5.38,0,9.74-4.36,9.74-9.74s-4.36-9.74-9.74-9.74Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83,21.74l-12.99-12.99c-1.61-1.61-1.61-4.22,0-5.83l2.92-2.92,18.76,18.76s.04.04.06.06c1.61,1.61,1.61,4.22,0,5.83h0s0,0,0,0,0,0,0,0l-18.82,18.82s-1.31-1.31-2.92-2.92c-1.61-1.61-1.61-4.22,0-5.83l12.99-12.99Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.74,0C14.46,0,12.62,1.85,12.62,4.13v35.22c0,2.28,1.85,4.12,4.12,4.12s4.12-1.85,4.12-4.12V4.13C20.86,1.85,19.02,0,16.74,0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.36,0c-2.28,0-4.12,1.85-4.12,4.12v35.22c0,2.28,1.85,4.12,4.12,4.12s4.12-1.85,4.12-4.12V4.13C33.48,1.85,31.63,0,29.36,0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.12,0H0v39.34c0,2.28,1.85,4.12,4.12,4.12s4.12-1.85,4.12-4.12V4.13C8.25,1.85,6.4,0,4.12,0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.16,61.37v-6.79l-3.09,4.5h-.05l-3.09-4.5v6.79H.37v-7.82h.55l3.14,4.63,3.14-4.63h.55v7.82h-.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.61,61.37l-.99-2.19h-4.61l-.99,2.19h-.6l3.64-7.88h.56l3.64,7.88h-.64ZM13.31,54.13l-2.07,4.53h4.12l-2.06-4.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.52,61.49c-1.16,0-1.89-.6-2.37-1.46l.48-.3c.48.82,1.01,1.24,1.92,1.24s1.7-.73,1.7-2.09v-5.32h.58v5.27c0,1.75-1.02,2.66-2.31,2.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.61,61.51c-2.37,0-3.92-1.89-3.92-4.02v-.02c0-2.13,1.58-4.05,3.94-4.05s3.92,1.89,3.92,4.02t0,.02c0,2.13-1.58,4.05-3.94,4.05ZM31.95,57.46c0-1.93-1.41-3.52-3.34-3.52s-3.32,1.56-3.32,3.5v.02c0,1.93,1.41,3.52,3.34,3.52s3.32-1.56,3.32-3.5v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.17,61.37l-2.49-3.24h-2.56v3.24h-.58v-7.82h3.29c1.69,0,2.79.92,2.79,2.22v.02c0,1.31-.97,2.06-2.29,2.23l2.58,3.34h-.74ZM40.03,55.8c0-1.05-.83-1.71-2.25-1.71h-2.67v3.52h2.64c1.31,0,2.28-.66,2.28-1.79v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.37,61.37h-3.4v-7.82h3.23c1.52,0,2.54.75,2.54,1.92v.02c0,1.06-.69,1.6-1.33,1.85.94.25,1.77.78,1.77,1.87v.02c0,1.31-1.12,2.13-2.8,2.13ZM51.14,55.53c0-.86-.7-1.44-1.96-1.44h-2.64v3.07h2.58c1.17,0,2.01-.57,2.01-1.61v-.02ZM51.58,59.22c0-.96-.84-1.52-2.38-1.52h-2.65v3.14h2.84c1.34,0,2.19-.61,2.19-1.6v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.12,61.37v-7.82h.58v7.82h-.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.85,54.09v7.29h-.58v-7.29h-2.73v-.54h6.03v.54h-2.73Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.84,61.51c-2.44,0-4.11-1.71-4.11-4.02v-.02c0-2.22,1.73-4.05,4.1-4.05,1.41,0,2.26.38,3.07,1.07l-1.08,1.31c-.6-.5-1.14-.79-2.05-.79-1.25,0-2.25,1.11-2.25,2.44v.02c0,1.43.98,2.48,2.37,2.48.63,0,1.18-.16,1.62-.47v-1.12h-1.73v-1.49h3.4v3.4c-.8.68-1.91,1.24-3.34,1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.59,61.37l-1.68-2.5h-1.35v2.5h-1.72v-7.82h3.58c1.84,0,2.95.97,2.95,2.58v.02c0,1.26-.68,2.06-1.68,2.42l1.91,2.79h-2.01ZM82.62,56.22c0-.74-.51-1.12-1.35-1.12h-1.71v2.25h1.74c.84,0,1.32-.45,1.32-1.11v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.72,61.51c-2.41,0-4.15-1.8-4.15-4.02v-.02c0-2.22,1.75-4.05,4.17-4.05s4.15,1.8,4.15,4.02v.02c0,2.22-1.75,4.05-4.17,4.05ZM92.09,57.46c0-1.34-.98-2.46-2.37-2.46s-2.35,1.1-2.35,2.44v.02c0,1.34.98,2.46,2.37,2.46s2.35-1.1,2.35-2.44v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.68,61.5c-2.1,0-3.39-1.17-3.39-3.48v-4.47h1.72v4.42c0,1.27.64,1.93,1.69,1.93s1.69-.64,1.69-1.88v-4.48h1.72v4.41c0,2.37-1.33,3.53-3.43,3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.9,59.03h-1.31v2.35h-1.72v-7.82h3.2c1.87,0,2.99,1.11,2.99,2.7v.02c0,1.81-1.41,2.75-3.16,2.75ZM108.31,56.29c0-.77-.54-1.18-1.4-1.18h-1.33v2.39h1.36c.86,0,1.36-.51,1.36-1.18v-.02Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMbLogo);
export default __webpack_public_path__ + "static/media/mb-logo.38a139224d73ded4c788df27d1d8898a.svg";
export { ForwardRef as ReactComponent };